import { useCallback, useEffect, useState } from 'react'
import appFunctionAPI, {
  ApplicationFunctionPropertyConfiguration,
} from '../../../../lib/commons/appFunction'
import BoolExpression from '../../../../utils/boolExpression'

export interface ExtensionInfo {
  propertyConfigurations: ApplicationFunctionPropertyConfiguration[]
}

export const useExtension = (
  functionUuid: string,
  projectUuid: string,
  ticketType: string | undefined,
  ticketListUuid: string | undefined
) => {
  const [extensions, setExtensions] = useState<ExtensionInfo | undefined>()

  const fetchPropertyConfigurations = useCallback(async () => {
    if (!ticketType || !ticketListUuid) {
      return []
    }
    const response = await appFunctionAPI.getPropertyConfiguraitons(
      functionUuid,
      [projectUuid, ticketType, ticketListUuid]
    )
    const configs = response.json.map(v => ({
      ...v,
      requiredIf: v.requiredIf ? BoolExpression.of(v.requiredIf) : undefined,
      editableIfC: v.editableIfC ? BoolExpression.of(v.editableIfC) : undefined,
      editableIfU: v.editableIfU ? BoolExpression.of(v.editableIfU) : undefined,
      hiddenIfC: v.hiddenIfC ? BoolExpression.of(v.hiddenIfC) : undefined,
      hiddenIfU: v.hiddenIfU ? BoolExpression.of(v.hiddenIfU) : undefined,
    })) as ApplicationFunctionPropertyConfiguration[]

    return configs
  }, [functionUuid, projectUuid, ticketType, ticketListUuid])

  const clearExtensions = useCallback(() => setExtensions(undefined), [])

  useEffect(
    () => {
      const fetch = async () => {
        const propertyConfigurations = await fetchPropertyConfigurations()
        setExtensions({
          propertyConfigurations,
        })
      }
      clearExtensions()
      fetch()
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [projectUuid, ticketListUuid]
  )

  return {
    extensions,
    clearExtensions,
  }
}
